<script>
  export default {
    props: ['campaign']
  }
</script>

<template>
  <div class="native-preview">
    <div class="embed-responsive embed-responsive-4by3">
      <div class="embed-responsive-item">
        <img :src="campaign.campaignImages[0].image.url" alt="" class="w-100 h-100" />
      </div>
    </div>
    <div class="">
      <h4 class="font-size-14 native-preview__headline">{{ campaign.digitalHeadline }}</h4>
      <p class="font-size-12 mb-0 native-preview__name">{{ campaign.advertiser.businessName }} | Sponsored</p>
    </div>
  </div>
</template>
